export const translations = {
  startDate:{
    pt: "Data inicial",
    en: "Start date",
    de: "Startdatum",
    es: "Fecha de inicio",
  },
  endDate:{
    pt: "Data final",
    en: "End date",
    de: "Enddatum",
    es: "Fecha final",
  },
  limpar: {
    pt: 'Limpar',
    en: 'To clean',
    de: 'Zum Reinigen',
    es: 'Para Limpiar',
  },
  filtrar: {
    pt: 'Filtrar',
    en: 'Filter',
    de: 'Filter',
    es: 'Filtrar',
  },
  exportFile: {
    pt: 'Exportar Excel',
    en: 'Export Excel',
    de: 'Excel Exportieren',
    es: 'Exportar Excel',
  },
  client: {
    pt: 'Cliente',
    en: 'Customer',
    de: 'Kunde',
    es: 'Cliente',
  },
  product: {
    pt: 'Produto',
    en: 'Product',
    de: 'Produkt',
    es: 'Producto',
  },
  type: {
    pt: 'Tipo',
    en: 'Type',
    de: 'Typ',
    es: 'Tipo',
  },
  entryDate: {
    pt: 'Data de Entrada',
    en: 'Entry Date',
    de: 'Eintrittsdatum',
    es: 'Fecha de Entrada',
  },
  lastUpdate: {
    pt: 'Última Atualização',
    en: 'Last Update',
    de: 'Letzte Aktualisierung',
    es: 'Última Actualización',
  }
};
